'use client';

import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Span } from 'atoms/Typography';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useRouter } from 'modules/next/hooks';
import { AppRoutes } from 'modules/shop/routes';
import { ActionButton } from './ActionButton';
import styles from './styles.module.css';

export const BackButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const t = useTranslations();

  return <ActionButton text={t('common.buttons.step-back')} action={onClick} />;
};

export const BackHomeButton: FC = () => {
  const router = useRouter();
  const t = useTranslations();

  return (
    <ActionButton
      text={t('common.buttons.home-page')}
      icon="arrowLongRight"
      action={() => router.push(AppRoutes.HOME)}
    />
  );
};

export const BackHomeCartButton: FC = () => {
  const router = useRouter();
  const t = useTranslations();

  return (
    <ActionButton
      text={t('common.buttons.cart-home-page')}
      icon="arrowRight"
      action={() => router.push(AppRoutes.HOME)}
      className={styles.cartBackButton}
      data-testId="cartBackButton"
    />
  );
};

export const BackHomeBreadcrumbButton = () => {
  const router = useRouter();
  const t = useTranslations();

  return (
    <div className={styles.home}>
      <Icon
        onClick={() => router.back()}
        className={styles.homeIcon}
        type={IconType.arrowLongLeft}
      />
      <Span onClick={() => router.push(AppRoutes.HOME)}>
        {t('breadcrumbs.home')}
      </Span>
    </div>
  );
};
